import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
/**
 * Filters out old timestamps from impressions data and sanitizes the structure.
 * @param {Object} impressions - The impressions data object
 * @param {Object.<string, Object>} impressions - Object of component names to their impression data
 * @param {Object.<string, Array<number>>} impressions[component] - Map of sitecore IDs to arrays of timestamps for each component
 * @returns {Object} Filtered and sanitized impressions object
 * @example
 * // Input:
 * {
 *   "component1": {
 *     "id1": [1625097600000, 1625184000000], // 30+ day old timestamp and recent timestamp
 *     "id2": [1625097600000] // 30+ day old timestamp
 *   },
 *   "component2": {
 *     "id3": [1625097600000] // 30+ day old timestamp
 *   }
 * }
 * // Output (after filtering old timestamps):
 * {
 *   "component1": {
 *     "id1": [1625184000000] // only recent timestamps kept
 *   }
 * }
 */
export function filterOldTimestamps(impressions) {
  if (!impressions || _typeof(impressions) !== 'object') {
    return {};
  }
  var thirtyDaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000;
  var result = {};
  var validKeyRegex = /^[A-Za-z0-9-]+$/;
  for (var _i = 0, _Object$entries = Object.entries(impressions); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      component = _Object$entries$_i[0],
      items = _Object$entries$_i[1];
    if (items && _typeof(items) === 'object') {
      var filteredItems = Object.fromEntries(Object.entries(items).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          id = _ref2[0],
          value = _ref2[1];
        return validKeyRegex.test(id) && Array.isArray(value);
      }).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          id = _ref4[0],
          value = _ref4[1];
        var recentTimestamps = value.filter(function (ts) {
          return typeof ts === 'number' && ts > thirtyDaysAgo;
        });
        return recentTimestamps.length > 0 ? [id, recentTimestamps] : null;
      }).filter(function (entry) {
        return entry != null;
      }));
      if (Object.keys(filteredItems).length > 0) {
        result[component] = filteredItems;
      }
    }
  }
  return result;
}
export function getRecoreImpressions() {
  try {
    var storedData = localStorage.getItem('recoreImpressions');
    if (!storedData) {
      return {};
    }
    var impressions = JSON.parse(storedData);
    if (!impressions || _typeof(impressions) !== 'object') {
      return {};
    }
    var filteredImpressions = filterOldTimestamps(impressions);
    localStorage.setItem('recoreImpressions', JSON.stringify(filteredImpressions));
    return filteredImpressions;
  } catch (e) {
    return {};
  }
}
//# sourceMappingURL=recoreImpressions.js.map